var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.927 10.653a1 1 0 0 0-1.414-1.414l-7.049 7.049-7.048-7.049A1 1 0 1 0 9 10.653l7.05 7.05-6.879 6.877a1 1 0 0 0 1.414 1.414l6.878-6.878 6.878 6.878a1 1 0 0 0 1.415-1.414l-6.879-6.878 7.05-7.049z"
  })));
};

export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzUgMzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGgKICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIGZpbGxSdWxlPSJldmVub2RkIgogICAgY2xpcFJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNMjUuOTI3IDEwLjY1M2ExIDEgMCAwMC0xLjQxNC0xLjQxNGwtNy4wNDkgNy4wNDktNy4wNDgtNy4wNDlBMSAxIDAgMTA5IDEwLjY1M2w3LjA1IDcuMDUtNi44NzkgNi44NzdhMSAxIDAgMDAxLjQxNCAxLjQxNGw2Ljg3OC02Ljg3OCA2Ljg3OCA2Ljg3OGExIDEgMCAwMDEuNDE1LTEuNDE0bC02Ljg3OS02Ljg3OCA3LjA1LTcuMDQ5eiIKICAvPgo8L3N2Zz4K";